import type { PageConfig } from "../../../components/content-blocks/forms/customer-form-types";

export const groupConfig: PageConfig[] = [
    {
        name: "groupDetails",
        title: "Group Applicant - He Rōpū",
        questions: [
            {
                name: "group",
                title: "Is this application for a group?",
                type: "radiogroup",
                choices: ["Āe", "Kāo"],
                isRequired: true,
            },
            {
                name: "groupName",
                title: "Group Name",
                placeHolder: "Ingoa o te rōpū",
                type: "text",
                visibleIf: "{group} = 'Āe'",
                isRequired: true,
            },
            {
                name: "groupMembers",
                title: "Please list the names of the Ngāti Kuia members",
                placeHolder: "Ngā tāngata o te rōpū",
                type: "comment",
                visibleIf: "{group} = 'Āe'",
                isRequired: true,
            },
        ],
    },
];
